import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            redirect: {name: 'jobs'}
        },
        {
            path: '/jobs',
            name: 'jobs',
            component: () => import('./components/Jobs')
        },
        {
            path: '/new_job',
            name: 'new_job',
            component: () => import('./components/Job/NewJob')
        },
        {
            path: '/add_job/:jobId',
            name: 'add_job',
            component: () => import('./components/Job/AddJob')
        },
        {
            path: '/edit_job/:jobId',
            name: 'edit_job',
            component: () => import('./components/Job/EditJob')
        },
        {
            path: '/job_list',
            name: 'job_list',
            component: () => import('./components/Job/JobList')
        },
        {
            path: '/availabilities',
            name: 'availabilities',
            component: () => import('./components/Availabilities/Availabilities')
        },
        {
            path: '/skills',
            name: 'skills',
            component: () => import('./components/Skills/Skills')
        },
        {
            path: '/tutorials',
            name: 'tutorials',
            component: () => import('./components/Tutorials/Tutorials')
        },
        {
            path: '/balance_and_transactions',
            name: 'balance_and_transactions',
            component: () => import('./components/PureContactBalanceAndTransactions/PureContactBalanceAndTransactions')
        },        {
            path: '/invoices',
            name: 'invoices',
            component: () => import('./components/Documents/Invoices')
        },        {
            path: '/download_pdf_list',
            name: 'download_pdf_list',
            component: () => import('./components/Documents/DownloadPdfList')
        },
        {
            path: '/missed_jobs',
            name: 'missed_jobs',
            component: () => import('./components/MissedJobs/MissedJobs')
        },
        {
            path: '/badges',
            name: 'badges',
            component: () => import('./components/Badges/Badges')
        },
        {
            path: '/leads',
            name: 'leads',
            component: () => import('./components/Leads/Leads')
        },
        {
            path: '/preferences',
            name: 'preferences',
            component: () => import('./components/Preferences/Preferences')
        },
    ]
})
